import { M8LegalRequesites } from 'services/production/types';
import { createUniqueRuntimeNumber } from 'utils/uniqueRuntimeNumberUtils';

export const createM8LegalRequisites = (): M8LegalRequesites => ({
  id: 0,
  unp: '',
  orgAdress: '',
  orgName: '',
});

export const createM8LegalRequisitesMock = (): M8LegalRequesites => ({
  id: createUniqueRuntimeNumber(),
  unp: '200057443',
  orgAdress: 'г.Минск п/у Колядичи, ул.Бабушкина,33',
  orgName: 'Теплица ООО',
});
